import { useIntl } from 'react-intl';

import { FulfillmentStatus } from 'constants/enums';
import { useAppSelector } from 'hooks';
import {
  formatEstimatedShipDay,
  formatFulfillmentDay,
  getFulfillmentStepLabel
} from 'utils/fulfillment';

interface IFulfillmentStatusLineProps {
  provider: string;
  event: IFulfillmentEvent;
  deviceId: string;
}

/** The provider's latest step before shipping, under an Ordered device's status. */
export const FulfillmentStatusLine = ({
  provider,
  event,
  deviceId
}: IFulfillmentStatusLineProps) => {
  const { formatMessage } = useIntl();
  const locale = useAppSelector((state) => state.intl.locale);
  const isException = event.status === FulfillmentStatus.EXCEPTION;
  const estimatedShipDay =
    event.status === FulfillmentStatus.PROCESSING
      ? formatEstimatedShipDay(event.details?.estimatedShipDate, locale)
      : null;

  let text: string;
  if (isException) {
    text = formatMessage({ id: 'devices.fulfillment.exceptionAt' }, { provider });
  } else if (estimatedShipDay) {
    text = formatMessage({ id: 'devices.fulfillment.shipsAround' }, { date: estimatedShipDay });
  } else {
    const day = formatFulfillmentDay(event.occurredAt, locale);
    const label = getFulfillmentStepLabel(formatMessage, event.status, event.providerStatus);
    text = day ? `${label} · ${day}` : label;
  }

  return (
    <span
      className={`d-block small ${isException ? 'text-danger' : 'text-muted'}`}
      data-test={`device-fulfillment-status-${deviceId}`}
      data-test-value={event.status}
    >
      {text}
    </span>
  );
};
